import * as ko from 'knockout';
import {NOTIFICATIONS} from 'Core/Components/Translation/Locales';
import {
    ConfirmationDialog,
    EVENTS as CONFIRMATION_DIALOG_EVENTS,
    Types as ConfirmationTypes
} from 'Core/Components/Dialogs/ConfirmationDialog/ConfirmationDialog';
import {UserManager} from 'User/UserManager';
import {NextPublicationHelper} from 'Core/NextPublication/NextPublicationHelper';

import NextPublicationBannerTemplate from 'Core/NextPublication/Templates/NextPublicationBanner.html';
ko.templates['Core/NextPublication/Templates/NextPublicationBanner'] = NextPublicationBannerTemplate;

export class NextPublicationBanner {
    public IsVisible: KnockoutObservable<boolean>;
    public Message: KnockoutObservable<string>;
    public ShowCloseButton: KnockoutObservable<boolean>;
    private _rawValue: string;

    constructor() {
        this.IsVisible = ko.observable(false);
        this.Message = ko.observable('');
        this.ShowCloseButton = ko.observable(false);
        this._rawValue = '';
    }

    Render(targetId: string) {
        const container = document.getElementById(targetId);
        if (!container) {
            return;
        }
        ko.cleanNode(container);
        ko.applyBindings(this, container);
    }

    Hide() {
        this.IsVisible(false);
    }

    Refresh() {
        this._rawValue = NextPublicationHelper.GetRawValue();

        if (this._rawValue && !NextPublicationHelper.IsValidFormat(this._rawValue)) {
            const user = UserManager.Instance.CurrentUser;
            if (user && user.IsSupportServer) {
                this.Message(NOTIFICATIONS.INVALID_NEXT_PUBLICATION_DATE);
                this.ShowCloseButton(false);
                this.IsVisible(true);
            } else {
                this.IsVisible(false);
            }
            return;
        }

        if (!NextPublicationHelper.ShouldShow(this._rawValue)) {
            this.IsVisible(false);
            return;
        }

        const displayDate = NextPublicationHelper.FormatForDisplay(this._rawValue);
        this.Message(NOTIFICATIONS.NEXT_PUBLICATION_SCHEDULED.replace('{date}', displayDate));
        this.ShowCloseButton(true);
        this.IsVisible(true);
    }

    GetTemplateName() {
        return 'Core/NextPublication/Templates/NextPublicationBanner';
    }

    OnCloseClicked() {
        const displayDate = NextPublicationHelper.FormatForDisplay(this._rawValue);
        const dialog = new ConfirmationDialog({
            Text: NOTIFICATIONS.NEXT_PUBLICATION_SCHEDULED.replace('{date}', displayDate),
            Type: ConfirmationTypes.Question,
            TextConfirm: NOTIFICATIONS.NEXT_PUBLICATION_CONFIRM_REMOVE,
            TextDecline: NOTIFICATIONS.NEXT_PUBLICATION_LEAVE_MESSAGE,
            Width: 600
        });

        dialog.On(CONFIRMATION_DIALOG_EVENTS.CONFIRM_SELECTED, this, () => {
            NextPublicationHelper.Dismiss(this._rawValue);
            this.IsVisible(false);
        });

        dialog.Show();
    }
}
